import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import LoadingAnimation from '@/shared/components/LoadingAnimation';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import RichTextEditor from '@/shared/components/RichTextEditor';
import { formatListValue } from '@/shared/components/FormattedListValue';
import Button from '@/shared/components/Button';
import PlaceholderModal from '@/shared/components/email/PlaceholderModal';
import emailMessages from '@/shared/components/email/emailMessages';
const EMAIL_SIGNATURE_TEMPLATE_CONTEXT = 13;
const messages = defineMessages({
    EditEmailSignatures: {
        id: 'EditEmailSignatures',
        defaultMessage: 'EditEmailSignatures',
    },
    Save: {
        id: 'Save',
        defaultMessage: 'Save',
    },
});
const EmailSignatureModal = ({ show, onClose, companyId }) => {
    const intl = useIntl();
    const [signatures, setSignatures] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [showPlaceholders, setShowPlaceholders] = useState(false);
    useEffect(() => {
        if (!show)
            return;
        setLoading(true);
        api.base
            .get(`/api/Template/EmailSignature/${companyId}`)
            .then(({ data }) => {
            if (data != null) {
                const mapped = data.map((x, idx) => (Object.assign(Object.assign({}, x), { initialContent: x.content || '', collapsed: idx !== 0 && !x.content })));
                setSignatures(mapped);
            }
        })
            .catch(handleHttpError(intl))
            .finally(() => setLoading(false));
    }, [show, companyId, intl]);
    const handleSave = async () => {
        if (saving)
            return;
        setSaving(true);
        try {
            await api.base.put('/api/Template/EmailSignature', signatures);
            onClose();
        }
        catch (error) {
            handleHttpError(intl)(error);
        }
        finally {
            setSaving(false);
        }
    };
    const toggleCollapsed = (index) => {
        setSignatures(prev => prev.map((sig, i) => (i === index ? Object.assign(Object.assign({}, sig), { collapsed: !sig.collapsed }) : sig)));
    };
    const updateContent = (index, content) => {
        setSignatures(prev => prev.map((sig, i) => (i === index ? Object.assign(Object.assign({}, sig), { content }) : sig)));
    };
    return (_jsxs(OkCancelModal, Object.assign({ title: intl.formatMessage(messages.EditEmailSignatures), show: show, onClose: onClose, onSave: handleSave, disabled: saving, size: "lg", okLabel: intl.formatMessage(messages.Save), zendeskArticle: "9576323609244", leftButton: _jsxs(Button, Object.assign({ onClick: () => setShowPlaceholders(true) }, { children: ['{', intl.formatMessage(emailMessages.Placeholders), '}'] })) }, { children: [showPlaceholders && (_jsx(PlaceholderModal, { onSave: () => setShowPlaceholders(false), onClose: () => setShowPlaceholders(false), templateContext: EMAIL_SIGNATURE_TEMPLATE_CONTEXT })), loading ? (_jsx(LoadingAnimation, {})) : (_jsx("div", { children: signatures.map((signature, index) => (_jsxs("div", Object.assign({ className: "control-panel subsection" }, { children: [_jsxs("div", Object.assign({ className: "title-block", onClick: () => toggleCollapsed(index) }, { children: [_jsx("i", { className: `fa fa-inverse ${signature.collapsed ? 'fa-chevron-circle-down' : 'fa-chevron-circle-up'}` }), "\u00A0", _jsx("span", { children: formatListValue({ list: 'language', id: signature.language, intl }) })] })), !signature.collapsed && (_jsx("div", Object.assign({ className: "panel-body" }, { children: _jsx(RichTextEditor, { id: `emailSignature-${signature.language}`, initialValue: signature.initialContent || '', onChange: (html) => updateContent(index, html) }, `emailSignature-${signature.language}`) })))] }), signature.language))) }))] })));
};
export default EmailSignatureModal;
